export enum Status {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
}
